import { CopyOutlined } from '@ant-design/icons';
import { DTIProps } from '@xometry/ui';
import { Space, Tooltip } from 'antd';
import { AntButton } from 'components/ant/AntButton/AntButton';
import { LinkButton } from 'components/UI/Link/styled';
import React from 'react';
import { copyToClipboard } from 'utils/clipboard';

interface Props extends DTIProps {
  copyValue: string;
  onClick: () => void;
  children: React.ReactNode;
}

export const CopyableLinkButton: React.FC<Props> = (props) => {
  const { 'data-testid': DTI, copyValue, onClick, children } = props;

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClick();
  };

  const handleCopy = (e: React.MouseEvent) => {
    e.stopPropagation();
    copyToClipboard(copyValue);
  };

  return (
    <Space size={4} data-testid={DTI}>
      <LinkButton type="link" onClick={handleClick} data-testid={`${DTI}__NumberButton`}>
        {children}
      </LinkButton>

      <Tooltip title="Copy to clipboard">
        <AntButton
          type="link"
          size="small"
          className="p-none"
          style={{ width: 'auto' }}
          icon={<CopyOutlined />}
          onClick={handleCopy}
          data-testid={`${DTI}__CopyButton`}
        />
      </Tooltip>
    </Space>
  );
};
